export default __webpack_public_path__ + "static/media/misconfiguration.8f162737.svg";